import React, { Component } from 'react';

class Faq extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accordion: [
                {
                    id: 1,
                    classname: 'accordion-item active',
                    heading: 'What types of plywood and MDF boards do you stock?',
                    text: 'We stock a comprehensive range of plywood including 3mm, 6mm, 9mm, and 18mm varieties. Our MDF boards come in various thicknesses and grades. We also carry blockboards, chipboards, marine boards, and MDF laminated sheets to suit all your construction and furniture needs.'
                },
                {
                    id: 2,
                    classname: 'accordion-item',
                    heading: 'Do you offer delivery services in Nairobi?',
                    text: 'Yes, we provide delivery services throughout Nairobi and surrounding areas. Our team ensures safe handling and timely delivery of all building materials. Contact us at 0706494665 to arrange delivery for your order.'
                },
                {
                    id: 3,
                    classname: 'accordion-item',
                    heading: 'Can you help me calculate material quantities for my project?',
                    text: 'Absolutely! Our experienced team provides free consultation and helps you determine the right quantities and types of materials needed for your construction or renovation project. Visit our store in Nairobi or call us for expert advice on material selection and cost estimation.'
                }
            ]
        }
    }
    
    render() {
        return (
            <div className="col-md-6">
                <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                <div className="themesflat-content-box" data-margin="0 0 0 18px" data-mobilemargin="0 0 0 0">
                    <div className="themesflat-headings style-1 clearfix">
                        <h2 className="heading">FREQUENTLY ASKED QUESTIONS</h2>
                        <div className="sep has-width w80 accent-bg margin-top-11 clearfix" />
                    </div>
                    <div className="themesflat-spacer clearfix" data-desktop={38} data-mobile={35} data-smobile={35} />
                    <div className="themesflat-accordions style-1 has-icon icon-left iconstyle-1 clearfix">
                        {
                            this.state.accordion.map(data => (
                                <div className={data.classname} key={data.id}>
                                    <h3 className="accordion-heading"><span className="inner">{data.heading}</span></h3>
                                    <div className="accordion-content">
                                        <div>{data.text}</div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>

        );
    }
}

export default Faq;